<template>
  <modal
    show
    dismissable
    body-classes="p-0"
    modal-classes="modal-md"
    @update:show="$emit('update:show', $event)"
  >
    <card class="card-form mb-0">
      <template slot="header">
        <h2 class="modal-title">Files for Invoice {{ invoiceId }}</h2>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="$emit('update:show', false)"
        >
          <i class="tim-icons icon-simple-remove" />
        </button>
      </template>
      <template v-if="files.length">
        <div v-for="file in files" :key="file.url" :class="$style.summary">
          <h4>{{ file.name }}</h4>
          <base-button type="default" size="sm" @click="downloadFile(file)">
            Download
          </base-button>
        </div>
      </template>
      <template v-else>
        <div v-if="loaded">No files found.</div>
        <div v-else>Loading...</div>
      </template>
    </card>
  </modal>
</template>

<script>
import { mapActions } from "vuex";
import { Modal } from "src/components/UI";
import api from "src/services/api.js";

export default {
  name: "FileDownloadModal",
  components: {
    Modal,
  },
  props: {
    invoiceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      files: [],
      loaded: false,
    };
  },
  async created() {
    try {
      this.files = await api.get("/invoices/" + this.invoiceId + "/files");
    } catch (error) {
      console.error(error);
    }
    this.loaded = true;
  },
  methods: {
    ...mapActions(["downloadFile"]),
  },
};
</script>

<style module>
.summary {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid #d2cfcf;
  margin-top: 10px;
}
</style>
